<template>
  <div class="container-fluid h-100 overflow-y">
    <div class="row flex-row h-100">
      <div class="col-12 my-auto">
        <div class="password-form mx-auto">
          <div class="logo-centered">
            <a href="#">
              <img src="../assets/logo.png" alt="logo" />
            </a>
          </div>
          <h3 class="mt-0">ورود به حساب کاربری</h3>
          <form v-on:submit.prevent action>
            <div class="group material-input">
              <input :type="state == 2 ? 'password' : 'txt'" name="username" class="mt-5 text-center" v-model="input" />
              <span class="highlight"></span>
              <span class="bar"></span>
              <label>{{ inputLabel }}</label>
            </div>
            <div class="button text-center">
              <button class="btn btn-lg btn-gradient-01" @click="login">
                ارسال
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios';
import authService from '../services/auth';
export default {
  name: 'Login',
  props: {
    msg: String,
  },
  data() {
    return {
      input: '',
      username: '',
      password: '',
      state: 0,
    };
  },
  computed: {
    inputLabel: function() {
      if (this.state == 0) return 'نام کاربری خود را وارد کنید';
      if (this.state == 1) return 'کد ارسال شده را وارد کنید';
      if (this.state == 2) return 'رمز عبور خود را وارد کنید';
      return '';
    },
  },
  methods: {
    async login() {
      try {
        if (this.state == 0) {
          await authService.login(this.input);
          this.username = this.input;
          this.state = 1;
          this.input = '';
          window.notif({ mssg: 'پیامک برای شما ارسال شد', isError: false });
        } else if (this.state == 1) {
          await authService.verify(this.input, this.username);
          this.input = '';
          this.state = 2;
          window.notif({ mssg: 'رمز ورود خودرا وارد کنید', isError: false });
        } else if (this.state == 2) {
          await authService.steptwo(this.input);
          //redirect admin dashboard
          window.notif({ mssg: 'خوش آمدید', isError: false });
          this.$router.push({ path: '/dashboard' });
        }
        // enter code
      } catch (err) {
        if (err.response.status == 404) {
          window.notif({ mssg: 'نام کاربری را صحیح وارد کنید', isError: true });
        } else if (err.response.status == 401 && this.state == 1) {
          window.notif({ mssg: 'کد ورود را صحیح وارد کنید', isError: true });
        } else if (err.response.status == 401 && this.state == 2) {
          window.notif({ mssg: 'رمز ورود را صحیح وارد کنید', isError: true });
        } else {
          window.notif({ mssg: 'مشکلی پیش آمده لطفا بعدا تلاش کنید', isError: true });
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
